/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsReplayLanePlayerDtoSchema } from "./replayLanePlayerDtoSchema.ts";
import { goodLuckCoreDTOsReplayLaneStatDtoSchema } from "./replayLaneStatDtoSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsReplayLaneMatchupDtoSchema = z.object({
  position: z.string().nullish(),
  get blue() {
    return goodLuckCoreDTOsReplayLanePlayerDtoSchema.optional();
  },
  get red() {
    return goodLuckCoreDTOsReplayLanePlayerDtoSchema.optional();
  },
  matched: z.optional(z.boolean()),
  get stats() {
    return z.array(goodLuckCoreDTOsReplayLaneStatDtoSchema).nullish();
  },
});
